import { Message } from './../../../app.models';
import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl, FormBuilder, FormGroup} from '@angular/forms';
import { User, UserProfile, UserWork, UserContacts, UserSocial, UserSettings } from '../user.model';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, Observable, startWith } from 'rxjs';
import { MatChipInputEvent, MatChipList, MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UserServiceService } from 'src/app/services/user-service.service';
import { Router } from '@angular/router';
import { Toast, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-mail',
  templateUrl: './user-mail.component.html',
  styleUrls: ['./user-mail.component.scss']
})
export class UserMailComponent implements OnInit {
  public form:UntypedFormGroup;
  public passwordHide:boolean = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  userCtrl = new FormControl('');//user
  filteredUser: Observable<{[key:string]:any}[]>;//user
  //fruits: string[] = ['Lemon'];
  usersEmail: string[] = [];//user
  allUser: {[key:string]:any}[] = [];//user
  public usersAll:any =[];
  @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;//user
  @ViewChild('chipListUser') chipListUser: MatChipList;//user
  Form:FormGroup;
  userIn:User;

  whereMail:string="all";

  constructor(public dialogRef: MatDialogRef<UserMailComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {[key:string]:any},
              public userService: UserServiceService,
              private fb:FormBuilder,
              public router: Router,
              public toast:ToastrService,
              private toastr: ToastrService,
              ) 
  {
      this.filteredUser = this.userCtrl.valueChanges.pipe(
        startWith(null),
        map((user: string | null) => (user ? this._filterUser(user) : this.allUser.slice())),
      );
      this.allUser= data.users;
      if(data.user)
      {
        if(data.user.email==null || data.user.email==undefined)
        {
          this.toastr.info("Désolé cet utiliasteur ne possède pas d'adresse mail \n completer ses information ");
          this.close();
        }
        else{
          this.whereMail="unique";
          this.usersEmail.push(data.user.email);
        }
      }
      else{
        this.whereMail="all";
      }
  }

  ngOnInit() {
    this.initForm();   
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }  else {
      this.router.navigate(['login']);
    }
  }

  initForm()
  {
    this.Form = this.fb.group({
      object:['',[Validators.required,Validators.maxLength(25)]],
      message:['',[Validators.required]]
    })
  }

  close(): void {
    this.dialogRef.close();
  }

  //AddUser in matchip

  addUser(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our user
    if (value && !this.usersEmail.includes(value)) {
      this.usersEmail.push(value);
    }
    // Clear the input value
    event.chipInput!.clear();
    this.userCtrl.setValue(null);
    this.desactiveErrorState();
  }

  removeUser(userMail: string): void {
    const index = this.usersEmail.indexOf(userMail);
    if (index >= 0) {
      this.usersEmail.splice(index, 1);
      this.desactiveErrorState();
    }
    
  }

  selectedUser(event: MatAutocompleteSelectedEvent): void {
    if(!this.usersEmail.includes(event.option.value))
    {
      this.usersEmail.push(event.option.value);
      this.userInput.nativeElement.value = '';
      this.userCtrl.setValue(null);
    }
    this.desactiveErrorState();
  }

  private _filterUser(value: string): Object[] {
    const filterValue = value.toLowerCase();
    return this.allUser.filter(user => user.user_name.toLowerCase().includes(filterValue) || user.user_surname.toLowerCase().includes(filterValue));
  }

  public sendMailUser()
  {
    if(this.usersEmail.length !=0)
    {
      let dataObject={
        idUser:this.userIn.id,
        mailUser:this.usersEmail,
        object:this.Form.get('object')?.value,
        message:this.Form.get('message')?.value,
      }
      this.userService.sendMailUser(dataObject).subscribe((res:any)=>{
        console.log(res);
        if(res.status ==1){
          this.toast.success(res.message,'Succès');
          this.close();
        }
        else{
          this.toast.error(res.message);
          if(res.description)
          {
            console.log(res.message);
          }
          else{
            this.toast.info("Corriger l'email et renvoyez le message à partie de cette email !","Info",{timeOut: 5000});
          }
        }
      })

    }
    else{
      this.desactiveErrorState();
    }
    
  }

  public selected(val:any)
  {
    this.whereMail=val;
    if(val=='all')
    {
      this.usersAll.forEach((elt:{[key:string]:any}) => {this.usersEmail.push(elt.email)});
    }
    this.userCtrl.setValue(null);
  }

  public desactiveErrorState()
  {
    if(this.usersEmail.length ==0)
    {
      this.chipListUser.errorState=true;
    }else{
      this.chipListUser.errorState=false;
    }
  }
}
